export enum SITE_PERMISSION {}
export const ADMIN_SITE_PERMISSIONS = [];
export const USER_SITE_PERMISSIONS = [];
export const SUBMITTER_SITE_PERMISSIONS = [];
